/* Check for dog Breed Value */
if ($('#SingleOptionBreed').length) {    

  $('#SingleOptionBreed').on('change', function() {
    selectedBreed = this.value;
    //console.log(selectedBreed);
    //alert(selectedBreed);
    if ( selectedBreed == "Afghanhund") {$(".size-value").text(" XXL	")}
    else if ( selectedBreed == "Airedaleterrier") {$(".size-value").text(" L	")}
    else if ( selectedBreed == "Akita") {$(".size-value").text(" XL	")}
    else if ( selectedBreed == "Alaskan klee kai") {$(".size-value").text(" M ")}
    else if ( selectedBreed == "Alaskan malamute") {$(".size-value").text(" XXL	")}
    else if ( selectedBreed == "American staffordshire terrier") {$(".size-value").text(" XL	")}
    else if ( selectedBreed == "Amstaff") {$(".size-value").text(" XL	")}
    else if ( selectedBreed == "Appenzeller sennenhund") {$(".size-value").text(" L	")}
    else if ( selectedBreed == "Australian cattledog") {$(".size-value").text(" L	")}
    else if ( selectedBreed == "Australian kelpie") {$(".size-value").text(" XL	")}
    else if ( selectedBreed == "Australian labradoodle") {$(".size-value").text(" XL	")}
    else if ( selectedBreed == "Australian shepherd") {$(".size-value").text(" XL	")}
    else if ( selectedBreed == "Australian stumpy tail cattle dog") {$(".size-value").text(" L	")}
    else if ( selectedBreed == "Australisk terrier") {$(".size-value").text(" M	")}
    else if ( selectedBreed == "Barbet") {$(".size-value").text(" XL	")}
    else if ( selectedBreed == "Basenji") {$(".size-value").text(" M	")}
    else if ( selectedBreed == "Basset hound") {$(".size-value").text(" L	")}
    else if ( selectedBreed == "Beagle") {$(".size-value").text(" L	")}
    else if ( selectedBreed == "Beagle-harrier") {$(".size-value").text(" L	")}
    else if ( selectedBreed == "Belgisk vallhund") {$(".size-value").text(" L	")}
    else if ( selectedBreed == "Berger picard") {$(".size-value").text(" L	")}
    else if ( selectedBreed == "Bichon frisé") {$(".size-value").text(" S	")}
    else if ( selectedBreed == "Bichon havanais") {$(".size-value").text(" M	")}
    else if ( selectedBreed == "Blodhund") {$(".size-value").text(" XXL	")}
    else if ( selectedBreed == "Border collie") {$(".size-value").text(" L	")}
    else if ( selectedBreed == "Borzoi") {$(".size-value").text(" XXL	")}
    else if ( selectedBreed == "Bostonterrier") {$(".size-value").text(" M	")}
    else if ( selectedBreed == "Boxer") {$(".size-value").text(" XL	")}
    else if ( selectedBreed == "Brandlbracke") {$(".size-value").text(" L	")}
    else if ( selectedBreed == "Bullterrier") {$(".size-value").text(" XL	")}
    else if ( selectedBreed == "Cairnterrier") {$(".size-value").text(" S	")}
    else if ( selectedBreed == "Cavalier King Charles spaniel") {$(".size-value").text(" M	")}
    else if ( selectedBreed == "Cavapoo") {$(".size-value").text(" M	")}  
    else if ( selectedBreed == "Chihuahua") {$(".size-value").text(" S	")}
    else if ( selectedBreed == "Chinese crested dog") {$(".size-value").text(" S	")}
    else if ( selectedBreed == "Chow chow") {$(".size-value").text(" L	")}
    else if ( selectedBreed == "Collie") {$(".size-value").text(" XL	")}
    else if ( selectedBreed == "Cockapoo") {$(".size-value").text(" L	")}  
    else if ( selectedBreed == "Cocker spaniel") {$(".size-value").text(" L	")}
    else if ( selectedBreed == "Corgi") {$(".size-value").text(" L	")}
    else if ( selectedBreed == "Dalmatiner") {$(".size-value").text(" XXL	")}
    else if ( selectedBreed == "Dobermann") {$(".size-value").text(" XXL	")}
    else if ( selectedBreed == "Dogo Argentino") {$(".size-value").text(" XL	")}
    else if ( selectedBreed == "Dvärgpinscher") {$(".size-value").text(" S	")}
    else if ( selectedBreed == "Dvärgpudel") {$(".size-value").text(" S	")}
    else if ( selectedBreed == "Dvärgschnauzer") {$(".size-value").text(" M	")}
    else if ( selectedBreed == "Engelsk bulldog") {$(".size-value").text(" L	")}
    else if ( selectedBreed == "Engelsk setter") {$(".size-value").text(" XL	")}
    else if ( selectedBreed == "Eurasier") {$(".size-value").text(" XL	")}
    else if ( selectedBreed == "Finsk lapphund") {$(".size-value").text(" L	")}
    else if ( selectedBreed == "Finsk spets") {$(".size-value").text(" L	")}
    else if ( selectedBreed == "Flatcoated retriever") {$(".size-value").text(" XXL	")}
    else if ( selectedBreed == "Foxterrier") {$(".size-value").text(" M	")}
    else if ( selectedBreed == "Fransk bulldog") {$(".size-value").text(" M	")}
    else if ( selectedBreed == "Golden retriever") {$(".size-value").text(" XXL	")}
    else if ( selectedBreed == "Gordonsetter") {$(".size-value").text(" XL	")}
    else if ( selectedBreed == "Greyhound") {$(".size-value").text(" XXL	")}
    else if ( selectedBreed == "Harrier") {$(".size-value").text(" L	")}
    else if ( selectedBreed == "Irländsk varghund") {$(".size-value").text(" XXL	")}
    else if ( selectedBreed == "Irländsk vattenspaniel") {$(".size-value").text(" L	")}
    else if ( selectedBreed == "Isländsk fårhund") {$(".size-value").text(" M	")}
    else if ( selectedBreed == "Italiensk vinthund") {$(".size-value").text(" M	")}
    else if ( selectedBreed == "Jack russell terrier") {$(".size-value").text(" M	")}
    else if ( selectedBreed == "Japanese chin") {$(".size-value").text(" S	")}
    else if ( selectedBreed == "Japansk spets") {$(".size-value").text(" S	")}
    else if ( selectedBreed == "Jämthund") {$(".size-value").text(" XXL	")}
    else if ( selectedBreed == "Kai ken") {$(".size-value").text(" L	")}
    else if ( selectedBreed == "Katter") {$(".size-value").text(" S	")}
    else if ( selectedBreed == "Kishu") {$(".size-value").text(" L	")}
    else if ( selectedBreed == "Kleiner münsterländer") {$(".size-value").text(" XL	")}
    else if ( selectedBreed == "Kooiker") {$(".size-value").text(" L	")}
    else if ( selectedBreed == "Kleinspitz") {$(".size-value").text(" M	")}
    else if ( selectedBreed == "Labradoodle") {$(".size-value").text(" L	")}
    else if ( selectedBreed == "Labrador") {$(".size-value").text(" XXL	")}
    else if ( selectedBreed == "Lagotto") {$(".size-value").text(" L	")}  
    else if ( selectedBreed == "Leonberger") {$(".size-value").text(" XXL	")}
    else if ( selectedBreed == "Malshipoo") {$(".size-value").text(" M	")}  
    else if ( selectedBreed == "Malteser") {$(".size-value").text(" S	")}
    else if ( selectedBreed == "Maltipoo") {$(".size-value").text(" M	")}
    else if ( selectedBreed == "Mittelspitz") {$(".size-value").text(" M	")}
    else if ( selectedBreed == "Mops") {$(".size-value").text(" M	")}
    else if ( selectedBreed == "Norfolkterrier") {$(".size-value").text(" S	")}
    else if ( selectedBreed == "Norsk elghund") {$(".size-value").text(" XL	")}
    else if ( selectedBreed == "Norsk lundehund") {$(".size-value").text(" M	")}
    else if ( selectedBreed == "Norwichterrier") {$(".size-value").text(" S	")}
    else if ( selectedBreed == "Nova scotia duck tolling retriever") {$(".size-value").text(" L	")}
    else if ( selectedBreed == "Papillon") {$(".size-value").text(" S	")}
    else if ( selectedBreed == "Parson") {$(".size-value").text(" S	")}
    else if ( selectedBreed == "Pekingese") {$(".size-value").text(" S	")}
    else if ( selectedBreed == "Pinscher") {$(".size-value").text(" L	")}
    else if ( selectedBreed == "Pitbull") {$(".size-value").text(" XL	")}
    else if ( selectedBreed == "Pomeranian") {$(".size-value").text(" S	")}
    else if ( selectedBreed == "Pudel") {$(".size-value").text(" L	")}
    else if ( selectedBreed == "Puli") {$(".size-value").text(" M	")}
    else if ( selectedBreed == "Pumi") {$(".size-value").text(" M	")}
    else if ( selectedBreed == "Rottweiler") {$(".size-value").text(" XXL	")}
    else if ( selectedBreed == "Saluki") {$(".size-value").text(" L	")}
    else if ( selectedBreed == "Samojedhund") {$(".size-value").text(" XXL	")}
    else if ( selectedBreed == "Sealyhamterrier") {$(".size-value").text(" M	")}
    else if ( selectedBreed == "Shetland sheepdog") {$(".size-value").text(" L	")}
    else if ( selectedBreed == "Shiba") {$(".size-value").text(" M	")}
    else if ( selectedBreed == "Shih tzu") {$(".size-value").text(" M	")}
    else if ( selectedBreed == "Siberian husky") {$(".size-value").text(" XXL	")}
    else if ( selectedBreed == "Silkyterrier") {$(".size-value").text(" S	")}
    else if ( selectedBreed == "Spansk vattenhund") {$(".size-value").text(" L	")}
    else if ( selectedBreed == "Staffordshire bullterrier") {$(".size-value").text(" L	")}
    else if ( selectedBreed == "Svensk Lapphund") {$(".size-value").text(" L	")}
    else if ( selectedBreed == "Sussex spaniel") {$(".size-value").text(" L	")}
    else if ( selectedBreed == "Tax") {$(".size-value").text(" M	")}
    else if ( selectedBreed == "Tibetansk spaniel") {$(".size-value").text(" S	")}
    else if ( selectedBreed == "Tibetansk terrier") {$(".size-value").text(" M	")}
    else if ( selectedBreed == "Toypudel") {$(".size-value").text(" S	")}
    else if ( selectedBreed == "Tysk schäferhund") {$(".size-value").text(" XXL	")}
    else if ( selectedBreed == "Tysk spets") {$(".size-value").text(" M	")}
    else if ( selectedBreed == "Volpino italiano") {$(".size-value").text(" S	")}
    else if ( selectedBreed == "Welshterrier") {$(".size-value").text(" M	")}
    else if ( selectedBreed == "West highland white terrier") {$(".size-value").text(" M	")}
    else if ( selectedBreed == "Whippet") {$(".size-value").text(" L	")}
    else if ( selectedBreed == "Yorkshireterrier") {$(".size-value").text(" S	")}
    else if ( selectedBreed == "Älghund") {$(".size-value").text(" L	")}

    else {
      $(".size-value").text("")
    }

    const recomendedOption =document.querySelector(".psr-tool .size-wrapper .size-value").innerText.trim();
    document.querySelectorAll(".variant-input-wrap select option").forEach(function(option) {
      option.removeAttribute("selected");
      const splitedValue=option.value.split(":");
      if (splitedValue[0].trim()==recomendedOption) {
        option.selected = true;
        option.parentNode.dispatchEvent(new Event('change', { bubbles: true }));
      }
  });

  });
}